import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/data";
import { Reveal, RevealStagger, StaggerItem, Cascade } from "@/components/Reveal";
import { useDetailModal } from "@/components/DetailModalContext";

const Icon = ({ name, className }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} strokeWidth={1.5} />;
};

export default function Services() {
  const { openDetail } = useDetailModal();
  return (
    <section id="hizmetler" className="scroll-mt-24" data-testid="services">
      <div className="container-shell">
        <Reveal className="max-w-2xl">
          <p className="overline">AKINSOFT Yazılım Çözümleri</p>
          <h2 className="heading-lg mt-4">
            <Cascade text="İşletmenizi büyüten {uçtan uca} çözümler." />
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink/60">
            Yazılımdan donanıma, kurulumdan desteğe kadar tüm dijital ihtiyaçlarınızı tek
            çatı altında karşılıyoruz.
          </p>
        </Reveal>

        <RevealStagger className="mt-[56px] grid grid-cols-1 gap-[32px] md:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s) => (
            <StaggerItem key={s.title}>
              <div
                className="group h-full cursor-pointer rounded-2xl border border-ink/5 bg-white p-8 shadow-[0_2px_10px_rgba(32,32,32,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_24px_50px_rgba(32,32,32,0.10)]"
                onClick={() => openDetail(s)}
                data-testid={`service-card-${s.title}`}
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-orange/10 text-orange transition-colors duration-500 group-hover:bg-orange group-hover:text-white">
                  <Icon name={s.icon} className="h-7 w-7" />
                </span>
                <h3 className="mt-6 text-xl font-bold tracking-tight text-ink">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink/60">{s.desc}</p>
                <button
                  onClick={() => openDetail(s)}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-ink transition-colors hover:text-orange"
                  data-testid={`service-detail-${s.title}`}
                >
                  Detaylı İncele
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            </StaggerItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
